import { createFileRoute } from "@tanstack/react-router";
import FakeApiGeneratorPage from "@/pages/FakeApiGeneratorPage";

export const Route = createFileRoute("/tools/fake-api-generator")({
  component: FakeApiGeneratorPage,
});
